import {
    forwardRef,
    type ForwardRefRenderFunction,
    type ReactNode,
    type FocusEventHandler,
} from 'react';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

type Props = {
    children: ReactNode | ReactNode[];
    onBlur?: FocusEventHandler;
    setMaxHeight?: boolean;
};
const DropdownBody: ForwardRefRenderFunction<HTMLDivElement, Props> = (
    { children, onBlur, setMaxHeight = true },
    ref
) => (
    <div
        ref={ref}
        onBlur={onBlur}
        className={classnames(
            dibsCss.relative,
            dibsCss.overflowYScroll,
            setMaxHeight && dibsCss.maxH600px
        )}
    >
        {children}
    </div>
);

export default forwardRef(DropdownBody);
